/* unplugin-vue-components disabled */import { render } from "./progressbar.vue?vue&type=template&id=7ba351c6&scoped=true"
import script from "./progressbar.vue?vue&type=script&setup=true&lang=js"
export * from "./progressbar.vue?vue&type=script&setup=true&lang=js"

import "./progressbar.vue?vue&type=style&index=0&id=7ba351c6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba351c6"],['__file',"src/controls/progressbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ba351c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ba351c6', __exports__)) {
    api.reload('7ba351c6', __exports__)
  }
  
  module.hot.accept("./progressbar.vue?vue&type=template&id=7ba351c6&scoped=true", () => {
    api.rerender('7ba351c6', render)
  })

}


export default __exports__